var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"title-card":_vm.$t('actions.categories'),"minHeight665":"true"}},[_c('table-dashboard',{attrs:{"headersUserManagement":_vm.headersUserManagement,"dataUserManagement":_vm.dataUserManagement}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }